/**
 * Quick-add: single variant → add directly; multiple variants → open "Choose options" modal
 */
(function() {
  var modal, overlay, closeBtn, atcBtn, variantOptions, variantValueEl, priceEl, compareEl, salePriceEl, badgeEl, productLinkEl, swiperEl, swiperWrapperEl, swiperInstance, contentEl;

  function init() {
    modal = document.getElementById('QuickAddModal');
    if (!modal) return;
    overlay = modal;
    closeBtn = modal.querySelector('.js-quick-add-modal-close');
    atcBtn = modal.querySelector('.js-quick-add-modal-atc');
    variantOptions = modal.querySelector('.quick-add-modal_variant-options');
    variantValueEl = modal.querySelector('.quick-add-modal_variant-value');
    priceEl = modal.querySelector('.quick-add-modal_price');
    compareEl = modal.querySelector('.quick-add-modal_compare');
    salePriceEl = modal.querySelector('.quick-add-modal_sale-price');
    badgeEl = modal.querySelector('.quick-add-modal_discount-badge');
    productLinkEl = modal.querySelector('[data-product-link]');
    swiperEl = modal.querySelector('[data-quick-add-swiper]');
    swiperWrapperEl = modal.querySelector('.quick-add-modal_swiper-wrapper');
    contentEl = modal.querySelector('.quick-add-modal_content');

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (atcBtn) atcBtn.addEventListener('click', function() { handleAddToCart(); });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
    });

    // Capture-phase click on quick-add
    document.addEventListener('click', handleQuickAddClick, true);
  }

  function handleQuickAddClick(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var variantId = btn.getAttribute('data-variant-id');
    var hasVariants = btn.getAttribute('data-has-variants') === 'true';
    var productHandle = btn.getAttribute('data-product-handle');

    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('is-expanded');

    if (hasVariants && productHandle) {
      openModal(btn, productHandle);
    } else {
      addToCartAndOpenDrawer(variantId);
    }

    btn.disabled = false;
    setTimeout(function() { btn.classList.remove('is-expanded'); }, 600);
  }

  function addToCartAndOpenDrawer(variantId) {
    document.body.classList.add('cart-open');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) { return r.text().then(function(t) { var d = {}; try { d = t ? JSON.parse(t) : {}; } catch(e) {} return { ok: r.ok, data: d }; }); })
    .then(function(res) {
      if (res.ok && typeof window.renderCart === 'function') window.renderCart(false);
      else if (!res.ok) console.error('[quick-add]', res.data);
    })
    .catch(function(err) { console.error('[quick-add]', err); });
  }

  function openModal(btn, productHandle) {
    if (!modal) return;
    atcBtn.disabled = true;
    if (contentEl) contentEl.classList.add('is-loading');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    fetch('/products/' + productHandle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        renderModal(product);
        atcBtn.disabled = false;
      })
      .catch(function(err) {
        console.error('[quick-add-modal] fetch failed:', err);
        if (contentEl) contentEl.classList.remove('is-loading');
        closeModal();
        atcBtn.disabled = false;
      });
  }

  function renderModal(product) {
    var v = product.variants;
    var selected = v[0];
    var optName = 'Option';
    var optValues = [];
    if (product.options && product.options[0]) {
      optName = typeof product.options[0] === 'string' ? product.options[0] : product.options[0].name || 'Option';
      if (product.options[0].values) {
        optValues = product.options[0].values;
      } else {
        var seen = {};
        v.forEach(function(variant) {
          var val = variant.option1 || variant.title;
          if (!seen[val]) { seen[val] = true; optValues.push(val); }
        });
      }
    } else {
      var seen = {};
      v.forEach(function(variant) {
        var val = variant.option1 || variant.title;
        if (!seen[val]) { seen[val] = true; optValues.push(val); }
      });
    }

    if (productLinkEl) {
      productLinkEl.href = '/products/' + product.handle;
      productLinkEl.textContent = product.title;
    }
    updatePriceDisplay(selected);
    if (variantValueEl) variantValueEl.textContent = (selected.option1 || selected.title).toUpperCase();

    // Variant label from first option name
    var labelEl = modal.querySelector('.quick-add-modal_variant-label');
    if (labelEl) labelEl.textContent = optName.toUpperCase();

    // Images — slider with 2 slides per view
    swiperWrapperEl.innerHTML = '';
    var imgs = product.images || [];
    if (imgs.length === 0 && product.featured_image) imgs = [product.featured_image];
    for (var i = 0; i < imgs.length; i++) {
      var imgSrc = imgs[i];
      if (typeof imgSrc === 'object' && imgSrc !== null && imgSrc.src) imgSrc = imgSrc.src;
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      var div = document.createElement('div');
      div.className = 'quick-add-modal_slide img-wrapper';
      var imgEl = document.createElement('img');
      imgEl.src = imgSrc;
      imgEl.alt = product.title;
      imgEl.loading = 'lazy';
      div.appendChild(imgEl);
      slide.appendChild(div);
      swiperWrapperEl.appendChild(slide);
    }
    initSwiper();

    // Variant buttons
    variantOptions.innerHTML = '';
    optValues.forEach(function(val) {
      var isSelected = String(val).toLowerCase() === String(selected.option1 || selected.title).toLowerCase();
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quick-add-modal_variant-btn' + (isSelected ? ' is-selected' : '');
      btn.textContent = String(val).toUpperCase();
      btn.dataset.value = val;
      btn.addEventListener('click', function() {
        variantOptions.querySelectorAll('.quick-add-modal_variant-btn').forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var valStr = String(val);
        var match = v.find(function(variant) {
          var o = String(variant.option1 || variant.title);
          return o.toLowerCase() === valStr.toLowerCase();
        });
        if (match) {
          modal._selectedVariant = match;
          variantValueEl.textContent = String(val).toUpperCase();
          updatePriceDisplay(match);
        }
      });
      variantOptions.appendChild(btn);
    });

    modal._selectedVariant = selected;
    if (contentEl) contentEl.classList.remove('is-loading');
  }

  function updatePriceDisplay(variant) {
    var compareAt = variant.compare_at_price;
    var price = variant.price;
    var onSale = compareAt && compareAt > price;
    var symbol = (modal && modal.getAttribute('data-currency-symbol')) || '£';

    if (priceEl) {
      priceEl.textContent = formatMoney(price);
      priceEl.classList.toggle('hidden', !!onSale);
    }
    if (compareEl) {
      if (onSale) {
        compareEl.textContent = formatMoney(compareAt);
        compareEl.classList.remove('hidden');
      } else {
        compareEl.classList.add('hidden');
      }
    }
    if (salePriceEl) {
      if (onSale) {
        salePriceEl.textContent = formatMoney(price);
        salePriceEl.classList.remove('hidden');
      } else {
        salePriceEl.classList.add('hidden');
      }
    }
    if (badgeEl) {
      if (onSale) {
        var pct = Math.round((1 - price / compareAt) * 100);
        badgeEl.textContent = pct + '% OFF';
        badgeEl.classList.remove('hidden');
      } else {
        badgeEl.classList.add('hidden');
      }
    }
  }

  function handleAddToCart() {
    var selected = modal && modal._selectedVariant;
    if (!selected || atcBtn.disabled) return;
    atcBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: selected.id, quantity: 1 })
    })
    .then(function(r) { return r.text().then(function(t) { var d = {}; try { d = t ? JSON.parse(t) : {}; } catch(e) {} return { ok: r.ok, data: d }; }); })
    .then(function(res) {
      if (res.ok) {
        closeModal();
        document.body.classList.add('cart-open');
        if (typeof window.renderCart === 'function') window.renderCart(false);
        if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) Shopify.PaymentButton.init();
      } else {
        console.error('[quick-add-modal]', res.data);
      }
    })
    .catch(function(err) { console.error('[quick-add-modal]', err); })
    .finally(function() { atcBtn.disabled = false; });
  }

  function initSwiper() {
    if (!swiperEl || !swiperWrapperEl) return;
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
    if (swiperWrapperEl.querySelectorAll('.swiper-slide').length === 0) return;
    if (typeof Swiper === 'undefined') {
      setTimeout(initSwiper, 50);
      return;
    }
    swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1.33,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        769: { slidesPerView: 2 }
      }
    });
  }

  function destroySwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  function closeModal() {
    if (!modal) return;
    if (contentEl) contentEl.classList.add('is-loading');
    destroySwiper();
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function() {
      overlay.setAttribute('aria-hidden', 'true');
    }, 350);
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    var symbol = (modal && modal.getAttribute('data-currency-symbol')) || '£';
    return symbol + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
